export const insights = {
  _root: "/insights"
};
